/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { usePolicyService } from "../../../services/policyService.js";

/* Components */
import UCModal from "../../ucmodal/index.js";
import Content from "./content.js";
import Footer from "./footer.js";
import { ReactComponent as PolicyIcon} from "../../../resources/images/aa-create-policy.svg";

/* Styles */
import styles from "./styles.js";

const ChangePolicyModal = ({showModal, setShowModal, setPolicy, teamId, policy, callback}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { changePolicy } = usePolicyService();

  const [policyDetails, setPolicyDetails] = useState(policy);

  useEffect(() => {
    setPolicyDetails(policy)
  }, [policy]);

  const handleSaveModal = async () => {
    if(policy !== policyDetails) {
      let reqBody = {
        policyId: policyDetails?.policyId || ""
      }
      const success = await changePolicy(reqBody, teamId)
      if(success) {
        setPolicy(policyDetails)
        await callback()
      }
    }
    setShowModal(false)
  }

  return (
    <UCModal
      className={classes.changePolicyModal}
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ <PolicyIcon /> }
      modalTitle={ <FormattedMessage id="changePolicyModal.title"/> }
      modalDescription={ <FormattedMessage id="changePolicyModal.description" /> }
      modalContent={ <Content policyDetails={policyDetails} setPolicyDetails={setPolicyDetails} /> }
      modalFooter={ <Footer setShowModal={setShowModal} handleSaveModal={handleSaveModal} /> }
      dataTestId="changepolicymodal"
      onExited={() => setPolicyDetails(policy)}
    />
  )
}

export default ChangePolicyModal;
